/**
 * section-main-search.js
 * Handles the clear button visibility and click behavior
 * for the site-wide search form.
 */

(function () {
  'use strict';

  /**
   * @param {HTMLElement} form
   */
  function initSearchForm(form) {
    /** @type {HTMLInputElement|null} */
    const input = form.querySelector('.search__input');
    /** @type {HTMLButtonElement|null} */
    const clearBtn = form.querySelector('.search__clear');

    if (!input || !clearBtn) return;

    const updateClearVisibility = () => {
      clearBtn.hidden = input.value.length === 0;
    };

    input.addEventListener('input', updateClearVisibility);

    clearBtn.addEventListener('click', () => {
      input.value = '';
      clearBtn.hidden = true;
      input.focus();
    });

    // Set initial state
    updateClearVisibility();
  }

  function init() {
    document.querySelectorAll('.search__form').forEach(initSearchForm);
  }

  // Initial run
  init();

  // Re-run on Theme Editor section reload
  document.addEventListener('shopify:section:load', (event) => {
    const section = /** @type {HTMLElement} */ (event.target);
    section.querySelectorAll('.search__form').forEach(initSearchForm);
  });
})();
